import StyledWMDialog from '../StyledWMDialog/StyledWMDialog';
import { WMButtonVariant } from '@walkme/wm-ui';
import React from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import classes from './DeleteDialog.module.scss';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.dialogs.deleteDialog';

interface IDeleteNotificationProps extends InstanceProps<$TSFixMe> {
    count: number;
    itemName: string;
    permanently?: boolean;
    children?: $TSFixMe;
}

export const DeleteDialog = ({ isOpen, onResolve, close, count, permanently = false, itemName, children }: IDeleteNotificationProps) => {
    const { t } = useTranslation('', { keyPrefix });

    const confirm = () => {
        onResolve(true);
    };

    const onClose = () => {
        close();
    };

    const buttons = [
        {
            children: t('cancel'),
            variant: WMButtonVariant.Primary,
            onClick: onClose,
            className: classes.cancelButton,
            'data-testid': `delete-${itemName}-dialog-decline-button`
        },
        {
            children: permanently ? t('deleteForever') : t('archive'),
            variant: WMButtonVariant.Primary,
            onClick: confirm,
            className: classes.deleteButton,
            'data-testid': `delete-${itemName}-dialog-confirm-button`
        }
    ];

    return (
        <StyledWMDialog
            title={permanently ? t('titleDelete', { count, itemName }) : t('titleArchive', { count, itemName })}
            open={isOpen}
            onClose={onClose}
            buttons={buttons}
            data-testid={`delete-${itemName}-dialog`}
        >
            {permanently ? t('undone') : null}
            {children}
        </StyledWMDialog>
    );
};

export const confirmDelete = create(DeleteDialog);
